import React from "react";

import ModalConfirm from "../../../molecules/ModalConfirm";

import styles from "./ReissueStudentPasswordModal.module.scss";

type Props = {
  student_name: string;
  onClose: () => void;
  onReissueStudentPassword: () => void;
};

export const ReissueStudentPasswordModal = ({
  student_name,
  onClose,
  onReissueStudentPassword,
}: Props) => {
  return (
    <ModalConfirm
      onClose={onClose}
      title={`本当に${student_name}さんの\nパスワードを再発行しますか？\n\nパスワード再発行をしたら、\n新しい仮パスワードを生徒に伝えてください。`}
      buttons={[
        {
          title: "キャンセル",
          action: onClose,
          type: "None",
        },
        {
          title: "OK",
          action: () => {
            onClose();
            onReissueStudentPassword();
          },
          type: "Success",
        },
      ]}
      fontSize="md"
      className={styles.modal}
    />
  );
};

export default ReissueStudentPasswordModal;
